import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-78" data-mp="ut5c1epqiztu">
      <div className="mx-auto max-w-3xl" data-id="element-79" data-mp="71zwl0npi9k2">
        <SectionHeading eyebrow="Frequently Asked Questions" title="Your Questions, Answered" data-id="element-80" data-mp="731g7tisg4de" />
        <div className="mt-10 divide-y divide-line rounded-2xl border border-line bg-paper" data-id="element-81" data-mp="24hx00vkx6oq">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-82" data-mp="c2e5sm11npjo" data-mpi={i}>
                <h3 data-id="element-83" data-mp="1seb56j1423ny">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 p-5 text-left text-[17px] font-bold leading-snug text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-cyan" data-id="element-84" data-mp="1sdi3hwh0e4co">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-cyan transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-85" data-mp="vu0ehdcxit33" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-86" data-mp="8465j6vqdoo4">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-87" data-mp="8234zswycd55">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-88" data-mp="nmwfrtkvive4">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <TransformCta label="I'm Ready — Give Me Access" data-id="element-89" data-mp="sfpikbws7tnk" />
      </div>
    </section>;
}